import * as React from 'react';
import { Col, Button, Input, Form, FormItemProps } from 'antd';
import { observer, Observer } from 'mobx-react';
import { RulesStores } from '../stores';
import { SearchRuleAutoCompleteSourceItem } from '../types/SearchRuleAutoCompleteSourceItem';
import { AutocompleteWithTextSelection } from '../../common/components/AutocompleteWithTextSelection';
import SearchTagAutoCompleteOptionRenderer from './SearchTagAutoCompleteOptionRenderer';

const FormItem = Form.Item;

type Props = RulesStores & {
    formItemLayout: FormItemProps;
};

type State = {
    focused: boolean;
};

class TagSearch extends React.Component<Props, State> {
    private tagsOptionRenderer: (item: SearchRuleAutoCompleteSourceItem, idx: number) => React.ReactNode;

    constructor(props: Props) {
        super(props);

        this.tagsOptionRenderer = SearchTagAutoCompleteOptionRenderer(props.RulesListUI!);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);

        this.state = {
            focused: false
        };
    }

    componentDidMount() {
        window.addEventListener('keyup', this.handleKeyUp);
    }

    componentWillUnmount() {
        window.removeEventListener('keyup', this.handleKeyUp);
    }

    handleKeyUp(e: KeyboardEvent) {
        const store = this.props.RulesListUI!;

        if (e.key === 'Enter' && this.state.focused) {
            store.setTagsFilteredValue(store.currentTagsInputValue);
        }
    }

    onFocus() {
        this.setState({ focused: true });
    }

    onBlur() {
        this.setState({ focused: false });
    }

    render() {
        const store = this.props.RulesListUI!;

        return (
            <Col span={6} style={{ display: 'block' }}>
                <FormItem {...this.props.formItemLayout} name="searchTag">
                    <Observer>
                        {() => (
                            <div className="global-search-wrapper" style={{ width: '100%' }}>
                                <AutocompleteWithTextSelection
                                    className="global-search alpha-autocomplete"
                                    style={{ width: '100%' }}
                                    options={store.tags
                                        .slice()
                                        .sort((a, b) => a.name.localeCompare(b.name))
                                        .map((t, i) => ({
                                            value: t.name,
                                            label: this.tagsOptionRenderer(t, i),
                                            key: `${t.name}-${i}`
                                        }))}
                                    onSearch={v => store.handleTagsOnSearch(v)}
                                    defaultActiveFirstOption={false}
                                    showSearch
                                    filterOption
                                    value={store.currentTagsInputValue || ''}
                                    onFocus={this.onFocus}
                                    onBlur={this.onBlur}
                                    onSelect={v => {
                                        const value = v as string;
                                        store.setTagsFilteredValue(value);
                                    }}
                                >
                                    <Input
                                        allowClear
                                        placeholder="Tags..."
                                        onChange={e => store.handleTagsOnSearch(e.target.value)}
                                        data-id="input-filter-tags"
                                        suffix={
                                            <Button
                                                onClick={() => store.setTagsFilteredValue(store.currentTagsInputValue)}
                                                data-id="input-filter-tags-search-icon"
                                                className="search-btn"
                                                type="ghost"
                                            >
                                                <i
                                                    className="alpha-icon md search-icon"
                                                    style={{ verticalAlign: 'middle' }}
                                                />
                                            </Button>
                                        }
                                    />
                                </AutocompleteWithTextSelection>
                            </div>
                        )}
                    </Observer>
                </FormItem>
            </Col>
        );
    }
}

export default observer(TagSearch);
